// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hy","loading":"hz","b":"hA","errorMsg":"hB","loadingMsg":"hC","successMsg":"hD","hideLoadingMsg":"hE","completed":"hF","a":"hG","kidsGreen":"hH"};